// extracted by mini-css-extract-plugin
export var active = "_d8-7";
export var container = "_d8-0";
export var evenWidth = "_d8-4";
export var large = "_d8-5";
export var outlet = "_d8-8";
export var slide = "_d8-2";
export var small = "_d8-6";
export var tab = "_d8-3";
export var tabs = "_d8-1";